// extracted by mini-css-extract-plugin
export default {"imageContainer":"Uba-z","summaryPar":"Vba-z","ratingCategories":"Wba-z","reviewerInfo":"Xba-z","reviewTypes":"Yba-z","expanded":"Zba-z"};